import React from 'react'
import {NoData} from '../../../../genericComponents/NoData'
import {
    SearchResultTableForClassificationAndPhrase
} from '../SearchResultTable/SearchResultTableForClassificationAndPhrase'
import {FullSearchResult} from '../../useFullSearch'

export const SearchResultsComponentForClassificationAndPhraseSearch = ({
                                                                           fullSearchResult
                                                                       }: {
    fullSearchResult: FullSearchResult
}) => {
    if (!fullSearchResult.isSearchFetching && fullSearchResult.searchResultControl.noFoundItems) return <NoData
        message="No part found!"></NoData>
    return <SearchResultTableForClassificationAndPhrase fullSearchResult={fullSearchResult}
    />
}